import { useMutation } from "@tanstack/react-query";
import { initiateServiceFn, wantBodyWorkFn, tyreWantChangeFn, serviceEndpointFn, uploadBodyworkFn } from "../../transactions/serviceBooking/serviceBooking";

export const useInitiateService = () => {
    return useMutation({
      mutationFn: (payload) => initiateServiceFn(payload),
    });
};
  
export const useWantBodyWork = () => {
    return useMutation({
        mutationFn: (payload) => wantBodyWorkFn(payload),
    });
}

export const useTyreWantChange = () => {
    return useMutation({
        mutationFn: (payload) => tyreWantChangeFn(payload),
    });
}

export const useServiceEndpoint = () => {
    return useMutation({
        mutationFn: (payload) => serviceEndpointFn(payload),
    })
}

export const useUploadBodyworkFn = () => {
    return useMutation({
        mutationFn: (payload) => uploadBodyworkFn(payload),
    })
}